import React from 'react'
import { LBButton, LBCopyIcon, lbToast } from '@linearb/buzz'

interface CopyButtonProps {
  text: string | number
  description?: string
  size?: 'icon' | 'default' | 'sm' | 'lg'
  variant?:
    | 'ghost'
    | 'default'
    | 'outline'
    | 'secondary'
    | 'link'
    | 'destructive'
  className?: string
  iconClassName?: string
  ariaLabel?: string
}

const CopyButton: React.FC<CopyButtonProps> = ({
  text,
  description,
  size = 'icon',
  variant = 'ghost',
  className = 'h-6 w-6',
  iconClassName = 'h-3.5 w-3.5',
  ariaLabel = 'Copy'
}) => {
  const handleCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(String(text))
      lbToast({
        title: 'Copied to clipboard',
        description: description || String(text),
        variant: 'success'
      })
    } catch (err) {
      console.error('Failed to copy:', err)
      lbToast({
        title: 'Failed to copy',
        description: 'Unable to copy to clipboard',
        variant: 'destructive'
      })
    }
  }

  return (
    <LBButton
      variant={variant}
      size={size}
      className={className}
      aria-label={ariaLabel}
      onClick={handleCopy}
    >
      <LBCopyIcon className={iconClassName} />
    </LBButton>
  )
}

export default CopyButton
